import axios from "@/axios";
import {Module} from "vuex";

const state = () => ({
    regions: [],
    blogRegions: []
});

const getters = {
    getRegions(state: any){
        return state.regions;
    },
    getBlogRegions(state: any){
        return state.blogRegions;
    }
};
const actions = {
    async fetchRegions({commit}: any, stateId: any){
        const response = await axios.get('/region/'+stateId);
        commit('saveRegions', response.data);
    },
    async fetchBlogRegions({commit}: any, stateId: any){
        const response = await axios.get('/blog/region/'+stateId);
        commit('saveBlogRegions', response.data);
    }
};
const mutations = {
    saveRegions(state: any, payload: any){
        state.regions = payload;
        localStorage.setItem('regions',JSON.stringify(state.regions))
    },
    saveBlogRegions(state: any, payload: any){
        state.blogRegions = payload;
        localStorage.setItem('blogRegions',JSON.stringify(state.blogRegions))
    }
};

export const regions: Module<any, any> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}